import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import whiteLogo from "../assets/logo/vidyalaya logo white logo.png";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleLinkClick = () => {
    setIsOpen(false); // Close the menu when a link is clicked
  };

  return (
    <nav className="flex justify-between py-7 !pb-0 !pt-5 flex-wrap padding lg:px-20 items-center bg-blue-600">
      <div className="container mx-auto flex justify-between items-center">
        {/* Logo */}
        <div className="max-sm:w-32">
          <a href="#home">
            <img src={whiteLogo} width={200} height={200} alt="whitelogo" className="cursor-pointer object-contain" />
          </a>
        </div>

        {/* Hamburger icon */}
        <div className="md:hidden">
          <button
            onClick={toggleMenu}
            className="text-white focus:outline-none z-50 relative"
          >
            {!isOpen ? (
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16m-7 6h7"
                />
              </svg>
            ) : null}
          </button>
        </div>

        {/* Links for desktop */}
        <div className="hidden md:flex md:items-center">
          <a href="#about" className="block text-white p-2 hover:bg-blue-700 rounded-md md:inline-block">
            About
          </a>
          <a href="#courses" className="block text-white p-2 hover:bg-blue-700 rounded-md md:inline-block">
            Courses
          </a>
          <a href="#resources" className="block text-white p-2 hover:bg-blue-700 rounded-md md:inline-block">
            Resources
          </a>
          <a href="#contact" className="block text-white p-2 hover:bg-blue-700 rounded-md md:inline-block">
            Contact
          </a>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isOpen && (
          <>
            {/* Background Blur */}
            <motion.div
              key="backdrop"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1, backdropFilter: "blur(8px)" }}
              exit={{ opacity: 0 }}
              className="bg-black bg-opacity-50 fixed inset-0 w-full h-full z-40"
              onClick={toggleMenu} // Close menu on background click
            />

            {/* Sliding Menu */}
            <motion.div
              key="menu"
              initial={{ y: "-100%" }} // Start above the view
              animate={{ y: 0 }} // Slide down to original position
              exit={{ y: "-100%" }} // Slide back up to hide
              transition={{ type: "spring", stiffness: 75, damping: 20 }}
              className="bg-blue-600 fixed top-0 right-0 w-full h-3/4 z-50 flex flex-col items-center justify-center space-y-6"
            >

              <a
                href="#about"
                className="text-white text-2xl hover:bg-blue-700 md:inline-block duration-150 px-4 py-2 rounded-md"
                onClick={handleLinkClick}
              >
                About
              </a>
              <a
                href="#courses"
                className="text-white text-2xl hover:bg-blue-700 md:inline-block duration-150 px-4 py-2 rounded-md"
                onClick={handleLinkClick}
              >
                Courses
              </a>
              <a
                href="#resources"
                className="text-white text-2xl hover:bg-blue-700 md:inline-block duration-150 px-4 py-2 rounded-md"
                onClick={handleLinkClick}
              >
                Resources
              </a>
              <a
                href="#contact"
                className="text-white text-2xl hover:bg-blue-700 md:inline-block duration-150 px-4 py-2 rounded-md"
                onClick={handleLinkClick}
              >
                Contact
              </a>
            </motion.div>
          </>
        )}
      </AnimatePresence>

      {/* Close button positioned absolutely */}
      {isOpen && (
        <button
          onClick={toggleMenu}
          className="absolute top-4 right-4 text-white focus:outline-none z-50"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      )}
    </nav>
  );
};

export default Navbar;
